import { forwardRef } from "react";
import { useEffect, useRef } from "react";

const PopupMenu2 = (
  {
    children,
    MenuContent,
    actionType,
    open,
    setOpen,
    type,
    position,
    showArrow,
    popupMenuClass,
    disabledPopup,
    headerLabel = "",
    buttonClass = "",
  },
  ref,
) => {
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);
  const handleMenuToggle = () => {
    if (disabledPopup) return;
    setOpen(!open);
  };

  function useOutsideAlerter(ref) {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setOpen(false);
        }
      }
      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  return (
    <div
      className={
        type === "custom"
          ? "menu_list"
          : type === "customNifty"
            ? "menu_list_performance"
            : type === "multiSort"
              ? "popup_menu_container sortingMenu"
              : "popup_menu_container"
      }
    >
      <button
        className={`children ${buttonClass}`}
        style={{ width: "fit-content" }}
        onClick={handleMenuToggle}
        aria-label={headerLabel}
      >
        {children}
      </button>
      {actionType === "hover" ? (
        <div
          style={{ ...position }}
          className={
            type === "custom" || type === "customNifty"
              ? "list_menu list_menu_hover"
              : "popup_menu popup_menu_hover"
          }
        >
          <MenuContent />
        </div>
      ) : (
        <div
          style={{ ...position }}
          ref={type !== "customNifty" ? ref : wrapperRef}
          className={
            type === "custom" || type === "customNifty"
              ? `list_menu ${open ? "list_menu_open" : "list_menu_close"}`
              : `popup_menu ${popupMenuClass || ""}  ${
                  showArrow === false ? "no_arrow" : ""
                } ${open ? "popup_menu_open" : "popup_menu_close"}`
          }
        >
          <MenuContent />
        </div>
      )}
    </div>
  );
};

export default forwardRef(PopupMenu2);
